var Profile = function() {
    var blockCriteriaActivation = true; /* flag used to block activateCriteria() calls until all sliders have been created
                                         NOTE: noUiSlider.create() apparently emits an 'update' event...
                                         So, we use this flag to block accidental criteria activation on init
                                         unless the user actually updates the slider values
                                        */

    var activateCriteria = function() {
        if (!blockCriteriaActivation &&
            $('#criteria').length > 0 &&
            !$('#criteria').hasClass('active')) {
            $('#criteria').addClass('active');
            // reset ages and area data attributes
            var age_span = $('#age');
            if (age_span.data('age') == '') {
                var age = $('#age_slider')[0].noUiSlider.get();
                age_span.data('age', age);
            }
            var seeking_age_from_span = $('#seeking_age_from');
            var seeking_age_to_span = $('#seeking_age_to');

            if (seeking_age_from_span.data('age') == '' || seeking_age_to_span.data('age') == '') {
                var values = $('#age_seeking_slider')[0].noUiSlider.get();
                seeking_age_from_span.data('age', values[0]);
                seeking_age_to_span.data('age', values[1]);
            }
            if ($('#area').data('selected') == '') {
                $('#area').data('selected', '1');
                $('#area').html('Αθήνα');
            }
        }
    };

    var changePwd = function() {
        UserDataValidation.hidePasswordPrompts();
        var pwd = $('#password').val();

        if (UserDataValidation.checkPwd(pwd, true)) {
            Ajax.changePwd(pwd, function(res) {
                if (!res || !res.success || res.success != 'ok') {
                    UserDataValidation.showPasswordErrorPrompt('server');
                } else {
                    UserDataValidation.showPasswordSuccess();
                }
            });
        }
    };

    var updateAccountSettings = function(data) {
        $('#act_success').hide();
        Ajax.updateAccountSettings(data, function(res) {
            if (res.success == 'ok') {
                $('#act_success').show();
            } else if (res.reason == 'fail_email') {
                UserDataValidation.showEmailErrorPrompt();
            } else if (res.reason == 'fail_username') {
                UserDataValidation.showUsernameErrorPrompts('server');
            } else {
                Modal.showAlertModal('Η ενημέρωση του λογαριασμού απέτυχε');
            }
        });
    };

    return {
        initSliders: function() {
            blockCriteriaActivation = true;
            // age_slider
            var age = $('#age').data('age');
            var handle = age != '' ? age : '20';
            noUiSlider.create($('#age_slider')[0], {
                start: [handle],
                range: {
                    'min': [20],
                    'max' : [80]
                },
                step: 1,
                connect: 'lower',
                format: {
                    to: function(val) {
                        return Math.floor(val);
                    },
                    from: function(str_val) {
                        return Math.floor(Number(str_val));
                    }
                }
            });
            $('#age_slider')[0].noUiSlider.on('update', function(values) {
                $('#age').data('age', values[0]);
                $('#age').html(values[0]);
                activateCriteria();
            });

            // age_seeking_slider
            var seeking_age_from = $('#seeking_age_from').data('age');
            var seeking_age_to = $('#seeking_age_to').data('age');
            var handle1 = seeking_age_from != '' ? seeking_age_from : '20';
            var handle2 = seeking_age_to != '' ? seeking_age_to : '80';
            noUiSlider.create($('#age_seeking_slider')[0], {
                start: [handle1, handle2],
                range: {
                    'min': [20],
                    'max' : [80]
                },
                step: 5,
                connect: true,
                format: {
                    to: function(val) {
                        return Math.floor(val);
                    },
                    from: function(str_val) {
                        return Math.floor(Number(str_val));
                    }
                }
            });
            $('#age_seeking_slider')[0].noUiSlider.on('update', function(values) {
                $('#seeking_age_from').data('age', values[0]);
                $('#seeking_age_from').html(values[0]);

                $('#seeking_age_to').data('age', values[1]);
                $('#seeking_age_to').html(values[1]);

                activateCriteria();
            });
            blockCriteriaActivation = false;
        },
        initPrefHandlers: function() {
            $('#criteria_reset_btn').click(function() {
                blockCriteriaActivation = true;
                $('#age_slider')[0].noUiSlider.set([20]);
                $('#age_seeking_slider')[0].noUiSlider.set([20, 80]);

                $('#age').data('age', '');
                $('#seeking_age_from').data('age', '');
                $('#seeking_age_to').data('age', '');

                $('#area').data('selected', '');
                $('#area').html('');

                $('#criteria').removeClass('active');
                blockCriteriaActivation = false;
            });
        },
        showInlineMissingPrefs: function(callback) {
            Common.initDropdowns();
            Profile.initSliders();
            $('#basic_prefs_save_btn').off();
            $('#basic_prefs_save_btn').click(function() {
                if ($('#gender_seeking_combo').data('selected') != 'mf' &&
                    $('#gender_seeking_combo').data('selected') != 'fm') {
                    $('#gender_seeking_btn').addClass('error');
                    return;
                }
                var gender = 'male';
                var gender_seeking = 'female';
                if ($('#gender_seeking_combo').data('selected') == 'fm') {
                    gender = 'female';
                    gender_seeking = 'male';
                }
                Ajax.updateBasicPrefs(
                    gender,
                    gender_seeking,
                    $('#age').data('age'),
                    $('#seeking_age_from').data('age'),
                    $('#seeking_age_to').data('age'),
                    $('#area').data('selected'),
                    0,
                    function(res) {
                        if (res != undefined && res['success'] == 'ok') {
                            State.prefs = res['info'].prefs;
                            callback();
                        }
                    });
            });
        },
        criteriaActive: function() {
            return $('#criteria').hasClass('active');
        },
        initAccountSettings: function() {
            UserDataValidation.init(true);

            $('#change_pass_btn').click(function() {
                changePwd();
            });
            $('.ii__pwd_container input').keyup(function(ev) {
                if (ev.which == 13) {
                    changePwd();
                }
            });
            $('#disable_account_anchor').click(function() {
                var confirmBody = 'Είσαι σίγουρος/η ότι θέλεις να διαγράψεις για πάντα το λογαριασμό σου;';
                Modal.showConfirmModal(confirmBody, function() {
                    Ajax.disableAccount(function(res) {
                        if (res.success != 'ok') {
                            Modal.showAlertModal('Η διαγραφή του λογαριασμού σου απέτυχε.');
                            return;
                        }
                        Loggedin.logout();
                    });
                });
            });

            $('#profile_save_btn').click(function() {
                // hide prompts
                UserDataValidation.hideUsernameErrorPrompts();
                UserDataValidation.hideEmailErrorPrompt();
                UserDataValidation.checkUsername(
                    $('#username').val(), function(error) {
                        if (error) {
                            return;
                        }
                        var data = new FormData($('#account_settings_form')[0]);
                        updateAccountSettings(data);
                    }
                );
            });

            $('.ii__toggle_push').on('click', function() {
                var notifsSwitch = document.getElementById(this.htmlFor);
                var pushSubscriptionHash = Common.jsCookies.getItem('push_subscription_hash');
                var createNewSubscription = function() {
                    if (!window.PushNotifications) {
                        notifsSwitch.checked = false;
                        return Modal.showAlertModal('Ο browser σας δεν υποστηρίζεται.');
                    }
                    return PushNotifications.createSubscription().then(function (res) {
                        if (res == 'denied') {
                            notifsSwitch.checked = false;
                        }
                    });
                };

                if (!notifsSwitch.checked && pushSubscriptionHash) {
                    return Ajax.togglePushSubscription('disable', pushSubscriptionHash);
                }
                if (notifsSwitch.checked && pushSubscriptionHash) {
                    return Ajax.togglePushSubscription('enable', pushSubscriptionHash).then(function(resp) {
                        if (resp.success == 'ok') {
                            return;
                        }  // otherwise => hash exists locally but not in db (unsubscribed/expired/..) - we need to create new one
                        return createNewSubscription();
                    });
                }
                if (notifsSwitch.checked && !pushSubscriptionHash) {  // create new subscription
                    return createNewSubscription();
                }
                // // in case of unchecked switch && no hash -> nothing to do
            });
        },
        initPhotoHandlers: function() {
            $('body').on('change', '#photo_upload', function() {
                var data = new FormData($('#photo_upload_form')[0]);
                $(this).attr('disabled', true);
                $('#photo_upload_btn').prop('disabled', true);
                $('#photo_upload_btn').toggleClass('with_image_icon with_loader');
                Ajax.uploadPhoto(data, function(res) {
                    $('#photo_upload_btn').toggleClass('with_image_icon with_loader');
                    if (res.success != 'ok') {
                        Modal.showAlertModal('Η προσθήκη της φωτογραφίας απέτυχε');
                    }
                    Ajax.getPhotos(function(res) {
                        if (res.success == 'ok') {
                            $('#user_photos').html(res.html);
                            if (res.count > 0 && $('#offline_continue_btn').length > 0) {
                                $('#offline_continue_btn').show();
                            }
                            $('#photo_upload').attr('disabled', false);
                        }
                    });
                });
            });

            $('body').on('click', '.ii__photo_delete_btn', function() {
                $(this).attr('disabled', true);
                Ajax.deletePhoto($(this).data('pid'), function(res) {
                    if (res.success !== 'ok') {
                        Modal.showAlertModal('Η διαγραφή της εικόνας απέτυχε');
                    }
                    Ajax.getPhotos(function(res) {
                        if (res.success == 'ok') {
                            $('#user_photos').html(res.html);
                            if (res.count == 0 &&
                                $('#offline_continue_btn').length > 0) {
                                $('#offline_continue_btn').hide();
                            }
                        }
                    });
                });
            });

            $('body').on('click', '.ii__set_as_avatar', function() {
                Ajax.avatarSet($(this).data('pid'), function(res) {
                    if (res.success !== 'ok') {
                        return Modal.showAlertModal('Ο ορισμός φωτογραφίας προφίλ απέτυχε: ' + res.error);
                    }
                    Ajax.getPhotos(function(res) {
                        if (res.success != 'ok') {
                            return;
                        }
                        $('#user_photos').html(res.html);
                        var avatarSrc = document.getElementById('current-avatar-img').src;
                        document.getElementById('menu-avatar-xs').src = avatarSrc;
                    });
                });
            });
        },
        profileInit: function() {
            Common.initDropdowns();
            Profile.initSliders();
            $('#basic_prefs_save_btn').click(function() {
                $('#profile_success').hide();
                if ($('#gender_seeking_combo').data('selected') != 'mf' &&
                    $('#gender_seeking_combo').data('selected') != 'fm') {
                    $('#gender_seeking_btn').addClass('error');
                    return;
                }
                var gender = 'male';
                var gender_seeking = 'female';
                if ($('#gender_seeking_combo').data('selected') == 'fm') {
                    gender = 'female';
                    gender_seeking = 'male';
                }
                Ajax.updateBasicPrefs(
                    gender,
                    gender_seeking,
                    $('#age').data('age'),
                    $('#seeking_age_from').data('age'),
                    $('#seeking_age_to').data('age'),
                    $('#area').data('selected'),
                    1,
                    function(res) {
                        if (res.success == 'ok') {
                            $('#profile_success').show();
                        } else {
                            Modal.showAlertModal('Η ενημέρωση των ρυθμίσεων απέτυχε.');
                        }
                    });
            });
            Profile.initPrefHandlers();
        },
        profileDetailsInit: function() {
            $('#profile_details_save_btn').click(function() {
                $('#profile_success').hide();
                Ajax.updateProfileDetails(
                    $('#moto').val(),
                    $('#work_or_studies').val(),
                    function(res) {
                        if (res.success == 'ok') {
                            $('#profile_details_success').show();
                        } else {
                            Modal.showAlertModal('Η ενημέρωση των ρυθμίσεων απέτυχε.');
                        }
                    });
            });
            $('body').on('click', '.ii__answer', function() {
                var qid = $(this).data('question');
                var aid = $(this).data('answer');
                if (qid == undefined || aid == undefined) {
                    return;
                }
                QuestionsUI.answerSelected(qid, aid);
                Ajax.answerQuestion(qid, aid, function(res) {
                    if (res.success == 'ok') {
                        $('#questionsContainer').html(res.html);
                    }
                });
            });
            $('body').on('click', '.ii__question_delete', function() {
                Ajax.deleteQuestion($(this).data('qid'), function(res) {
                    if (res.success == 'ok') {
                        $('#questionsContainer').html(res.html);
                    }
                });
            });
            Profile.initPrefHandlers();
        },
        profilePhotosInit: function() {
            Profile.initPhotoHandlers();
            $('#profile_details_save_btn').click(function() {
                $('#profile_success').hide();
                Ajax.updateProfileDetails(
                    $('#moto').val(),
                    function(res) {
                        if (res.success == 'ok') {
                            $('#profile_details_success').show();
                        } else {
                            Modal.showAlertModal('Η ενημέρωση των ρυθμίσεων απέτυχε.');
                        }
                    });
            });
            Profile.initPrefHandlers();
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = Profile;
}
